import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { SelectedGoods, WorkTaskOrderInfo } from '../../models/Goods';
import { OrderDTO } from '../../api/api';

interface OrderGoodsState {
  goodsList: SelectedGoods[];
  deliveryLocation: {
    id: string;
    name: string;
  };
  deliveryDate: string;
  notes: string;
  selectedOrderReceipt?: OrderDTO;
  workTaskInfo?: WorkTaskOrderInfo;
  showOrderGoods: boolean;
}

const initialState: OrderGoodsState = {
  goodsList: [],
  deliveryLocation: { id: '', name: '' },
  deliveryDate: '',
  notes: '',
  selectedOrderReceipt: undefined,
  workTaskInfo: undefined,
  showOrderGoods: false
};

const orderGoodsSlice = createSlice({
  name: 'orderGoods',
  initialState: initialState,
  reducers: {
    setOrderGoodsList: (state: OrderGoodsState, action: PayloadAction<SelectedGoods[]>) => {
      state.goodsList = action.payload;
    },
    setSelectedDeliveryLocation: (state: OrderGoodsState, action: PayloadAction<{ id: string; name: string }>) => {
      state.deliveryLocation = action.payload;
    },
    setDeliveryDate: (state: OrderGoodsState, action: PayloadAction<string>) => {
      state.deliveryDate = action.payload;
    },
    setNotes: (state: OrderGoodsState, action: PayloadAction<string>) => {
      state.notes = action.payload;
    },
    setSelectedOrderReceipt: (state: OrderGoodsState, action: PayloadAction<OrderDTO | undefined>) => {
      state.selectedOrderReceipt = action.payload;
    },
    setWorkTaskOrderInfo: (state: OrderGoodsState, action: PayloadAction<WorkTaskOrderInfo>) => {
      state.workTaskInfo = action.payload;
    },
    resetOrderGoods: (state: OrderGoodsState) => {
      state.goodsList = initialState.goodsList;
      state.deliveryLocation = initialState.deliveryLocation;
      state.deliveryDate = initialState.deliveryDate;
      state.notes = initialState.notes;
      state.selectedOrderReceipt = initialState.selectedOrderReceipt;
      state.workTaskInfo = initialState.workTaskInfo;
      state.showOrderGoods = initialState.showOrderGoods;
    },
    setShowOrderGoods: (state: OrderGoodsState, action: PayloadAction<boolean>) => {
      state.showOrderGoods = action.payload;
    }
  }
});

export const {
  setOrderGoodsList,
  setSelectedDeliveryLocation,
  setDeliveryDate,
  setNotes,
  setSelectedOrderReceipt,
  setWorkTaskOrderInfo,
  resetOrderGoods,
  setShowOrderGoods
} = orderGoodsSlice.actions;
export const selectOrderGoodsList = (state: RootState) => state.orderGoodsReducer.goodsList;
export const selectOrderGoodsDeliveryLocation = (state: RootState) => state.orderGoodsReducer.deliveryLocation;
export const selectOrderGoodsDeliveryDate = (state: RootState) => state.orderGoodsReducer.deliveryDate;
export const selectOrderGoodsNotes = (state: RootState) => state.orderGoodsReducer.notes;
export const selectSelectedOrderReceipt = (state: RootState) => state.orderGoodsReducer.selectedOrderReceipt;
export const selectWorkTaskOrderInfo = (state: RootState) => state.orderGoodsReducer.workTaskInfo;
export const selectShowOrderGoods = (state: RootState) => state.orderGoodsReducer.showOrderGoods;

export default orderGoodsSlice.reducer;
